import React from 'react';

const WithWhatsapp = ({ number, name }) => {
	return (
		<div style={{ padding: "10px", backgroundColor: "#fff" }}>
			<span style={{ spanAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>{number}</span>
			<br />
			<span style={{ spanAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>{name}</span>
			<div style={{ flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 10 }}>
				<a style={{ padding: "10px", borderRadius: "10px" }}
					href={`https://wa.me/977${number}?span=नमस्ते Network Educational Academy 🙏`
					}
				>
					<span>
						<i className="fa fa-whatsapp" style={{ fontSize: 30 }} />
					</span>
				</a>
				<a style={{ padding: "10px", borderRadius: "10px" }}
					// 				href={`viber://chat/?number=${number}?text=
					// नमस्ते Network Educational Academy 🙏
					// म Network Educational Academyको प्रयोगकर्ता हुँ।
					// `
					href={`viber://chat?number=977${number}`}

				>
					<span>
						<img src='https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/viber.jpg' className="fa fa-viber" style={{ width: "50px" }} />
					</span>
				</a>
				<a style={{ padding: 10, borderWidth: 0.5, borderColor: "#ddd", borderRadius: 10 }}
					href={`tel:${number}`}
				>
					<span>
						<i className="fa fa-phone" style={{ fontSize: 30 }} />
					</span>
				</a>
			</div>
		</div>
	)
}


const WithoutWhatsapp = ({ number }) => {
	return (
		<div>
			<span style={{ spanAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>{number}</span>
			<div style={{ flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 10 }}>
				<a style={{ padding: 10, borderWidth: 0.5, borderColor: "#ddd", borderRadius: 10 }}
					href={`tel:${number}`}
				>
					<span>
						<i className="fa fa-phone" style={{ fontSize: 30 }} />
					</span>
				</a>
			</div>
		</div>
	)
}


export default function ContactUSLogin() {
	return (
		<div className='row'>
			<div className="row">
				{/* {loginSuccess &&
			<Navigate to="/" />
		} */}
				{/* <div className="col-lg-2 col-1"></div>
				<div className="col-lg-8 col-10 shadow signin-container" style={{ backgroundColor: "#fff" }}> */}

				<div>
					<div style={{ backgroundColor: "#fff", borderColor: "#bbb", borderWidth: 1, margin: 10, padding: 10 }}>
						<span style={{ spanAlign: "center" }}>
							{/* तपाई पहिलो पटक Network Educational Academy तल दिईएको सम्पर्क नम्बरमा सम्पर्क गर्नु  होला |{"\n"} */}
							{/* Network Educational Academy - लोकसेवा नेटवर्क - NEA मा भइरहेका तयारी कक्षामा जोडिन चाहनुहुन्छ भने थप जानकारीको लागि दिइएको सम्पर्क नम्बरमा Phone अथवा WhatsApp /Viber मा सम्पर्क गर्नुहोला । */}
							तपाईको परीक्षा लोकसेवा नेटवर्क -NEA को Platform मा दर्ता भएको छ ।
							यसको नतिजा भोलि दिउँसो २ बजे लोकसेवा नेटवर्क Facebook page मा प्रकाशन गरिने छ । केहि समस्या भएमा Viber /WhatsApp मा Message गर्नुहोस् ।
						</span>
					</div>
					<div style={{ display: 'flex' }}>
						<div style={{ width: "100%", borderColor: "#bbb", borderWidth: 1, padding: 10, margin: 10, marginTop: 0, backgroundColor: "#fff" }}>

							<div style={{ display: 'flex' }}>
								<div style={{ width: "50%" }}>
									<WithWhatsapp number={"9844832140"} name="R.K. sir" />
								</div>
								<div style={{ width: "50%" }}>
									<WithWhatsapp number={"9844085262"} name="Nirajan Sir" />
								</div>

							</div>
						</div>

					</div>
					<div style={{ width: "66%", borderColor: "#bbb", borderWidth: 1, padding: 10, margin: 10, marginTop: 0, backgroundColor: "#fff" }}>
						<span style={{ spanAlign: "left" }}>
							Landline :
						</span>
						<div style={{ display: 'flex' }}>
							<div style={{ width: "50%" }}>
								<WithoutWhatsapp number={"01-5921577"} />
							</div>
						</div>
					</div>
					{/* <div style={{ marginVertical: 10, margin: 5, padding: 10, borderWidth: 1, backgroundColor: `#fff`, borderRadius: 10 }}>
							<div style={{ flexDirection: "row" }}>
								<div style={{ width: "25%", justifyContent: "center" }}>
									<img src={`https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/viber-2.jpg`} style={{ width: "100%", }} resizeMode="contain" />
								</div>
							</div>
						</div> */}
				</div>
				{/* </div> */}
			</div>
		</div>
	)
}